/** @type {Record<string, { title: string, description: string, target: string }[]>} */
export const GUIDE_HINTS = {
  "tracking.add_provider": [
    {
      title: "Provider type",
      description: "Choose FindTEU-compatible for ocean containers or Ship24 for parcels.",
      target: '[data-guide="tracking.add_provider.type"]',
    },
    {
      title: "API key",
      description: "Paste the key from your provider dashboard. Orderlink encrypts it at rest.",
      target: '[data-guide="tracking.add_provider.api_key"]',
    },
    {
      title: "Create provider",
      description: "Save to continue with connection testing and webhooks.",
      target: '[data-guide="tracking.add_provider.submit"]',
    },
  ],
  "tracking.test_connection": [
    {
      title: "Test connection",
      description: "Run a quick check against your provider. This does not start tracking yet.",
      target: '[data-guide="tracking.test_connection"]',
    },
  ],
  "tracking.webhook": [
    {
      title: "Webhook URL",
      description: "Copy this URL into your provider's webhook settings.",
      target: '[data-guide="tracking.webhook.url"]',
    },
  ],
  "tracking.first_shipment": [
    {
      title: "Add tracking",
      description: "Open a shipment, go to Tracking, and register a container or parcel.",
      target: '[data-guide="tracking.first_shipment"]',
    },
  ],
  "shopify.connect_store": [
    {
      title: "Install from Shopify",
      description:
        "Orderlink is installed from the Shopify App Store. Approve access, then you come back here to link the store.",
      target: '[data-guide="shopify.connect_store.continue"]',
    },
  ],
  "shopify.locations": [
    {
      title: "Map each location",
      description:
        "Pick the Orderlink facility that fulfils each Shopify location. Stock and orders only sync for mapped locations.",
      target: '[data-guide="shopify.locations.panel"]',
    },
    {
      title: "Save and continue",
      description: "Next Step saves your mappings before moving on.",
      target: '[data-guide="shopify.wizard.next"]',
    },
  ],
  "shopify.catalogue": [
    {
      title: "Sales price list",
      description: "Orderlink publishes products and prices to Shopify from this price list.",
      target: '[data-guide="shopify.catalogue.pricelist"]',
    },
    {
      title: "Sync from Shopify",
      description:
        "Shopify owns your catalogue, so import its products here. Each variant is matched to an Orderlink product by SKU.",
      target: '[data-guide="shopify.catalogue.sync"]',
    },
    {
      title: "Save and continue",
      description: "Next Step saves your settings before moving on.",
      target: '[data-guide="shopify.wizard.next"]',
    },
  ],
  "shopify.tax": [
    {
      title: "Map Shopify taxes",
      description:
        "Match each Shopify tax line to an Orderlink tax rate so invoices total correctly.",
      target: '[data-guide="shopify.tax.panel"]',
    },
  ],
  "shopify.payment": [
    {
      title: "Map payment methods",
      description: "Match each Shopify payment method to the Orderlink account it is paid into.",
      target: '[data-guide="shopify.payment.panel"]',
    },
  ],

  // First-visit tips: shown once per person, the first time they open a screen.
  "screen.operations_home": [
    {
      title: "Your day at a glance",
      description:
        "Orders waiting on you, arrivals and sync problems, all in one line. One look, then coffee.",
      target: '[data-guide="operations.today"]',
    },
    {
      title: "Mine or everyone",
      description: "Flip to Mine to see just your orders. Flip back when you're feeling generous.",
      target: '[data-guide="operations.today.scope"]',
    },
  ],
  "screen.sales_order_list": [
    {
      title: "Every order, one list",
      description:
        "Orders from Shopify, the B2B portal, and the ones you type in by hand all land here. Like an inbox, but this one pays the bills.",
      target: '[data-guide="list.salesOrder"] thead',
    },
    {
      title: "Save your favourite filters",
      description:
        "Set up a filter you use every day and save it as a view. Future you says thanks.",
      target: '[data-guide="list.salesOrder.views"] > *',
    },
  ],
  "screen.create_sales_order": [
    {
      title: "Start with the customer",
      description:
        "Pick the customer first. Their currency comes along for the ride, and their shipping and billing addresses are ready to pick.",
      target: "#sales-order-details .field:first-child",
    },
    {
      title: "Add items",
      description:
        "Search by product code or name and add as many as you need in one go. Removed one by accident? Hit Undo in the message — no harm done.",
      target: '[data-guide="sales_order.add_items"]',
    },
    {
      title: "Save Draft or Submit",
      description:
        "Not ready? Save Draft and come back later. Commitment issues are allowed here. Submit makes it official.",
      target: '[data-guide="sales_order.submit"]',
    },
  ],
  "screen.price_list": [
    {
      title: "Who pays what",
      description:
        "Price lists set what your customers pay. Pick one on a sales order and the line prices fill themselves in. No mental arithmetic required.",
      target: '[data-guide="list.pricelist"] thead',
    },
  ],
  "screen.purchase_order_list": [
    {
      title: "Everything you've ordered",
      description:
        "What's coming, when it's due, and what you still owe suppliers. Your supplier to-do list, minus the sticky notes.",
      target: '[data-guide="list.purchase"] thead',
    },
    {
      title: "Watch the ETA column",
      description:
        "Late deliveries show up here first — well before they show up as an unhappy customer.",
      target: '[data-guide="list.purchase"] th[data-column-key="eta"]',
    },
  ],
  "screen.shipment_detail": [
    {
      title: "Know where it is",
      description:
        "Add a container or parcel number here and we'll keep checking on it, so you don't have to refresh the carrier's website 40 times a day.",
      target: '[data-guide="shipment.tracking"] > *',
    },
    {
      title: "Give it a name you'll recognise",
      description:
        'Call it something like "Shanghai October restock". Future you, searching for it at 4:55 pm on a Friday, will be grateful.',
      target: '[data-guide="shipment.name"]',
    },
  ],
};
